import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const AdminProtected = ({ component: Cmp, ...rest }) => (
    <Route
        {...rest}
        render={(props) => localStorage.getItem("admin") || localStorage.getItem("emp") || localStorage.getItem("reseller") ? (
            <Cmp {...props} />
        ) :
            <Redirect to='/login' />
        }
    />
)

export default AdminProtected;